import Sparkle from "@/assets/svg/Sparkle.svg?react";
import { TemplateStudioStatusPill } from "@/components/ui/report/TemplateStudioStatusPill/TemplateStudioStatusPill";

export interface TemplateStudioChatHeaderProps {
  isWorking: boolean;
}

export const TemplateStudioChatHeader = ({
  isWorking,
}: TemplateStudioChatHeaderProps) => (
  <div className="flex h-14 shrink-0 items-center justify-between gap-3 border-b border-gray-200 bg-white px-4">
    <span className="flex min-w-0 items-center gap-1.5">
      <Sparkle aria-hidden className="size-3.5 shrink-0" />
      <span className="text-sm font-semibold text-gray-900">Herald</span>
    </span>
    <TemplateStudioStatusPill isWorking={isWorking} />
  </div>
);
